import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ApplicationRoles, EdlEmail, PortalService, SessionService, User } from '@edl-development/edl-common';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ModalService } from '../../modals/modal.service';
import { AccessRoleHelper } from '../../model/helpers/access-role.helper';


@Component({
    selector: 'email-content',
    templateUrl: './email-content.component.html',
    styleUrls: ['../administration.component.scss']
})
export class EmailContentComponent implements OnInit {

    ApplicationRoles = ApplicationRoles;
    busy:boolean;
    currentEmail: EdlEmail;
    emails: [EdlEmail];
    form: UntypedFormGroup;
    portalID:number;
    portalName: string;
    settingsForm: UntypedFormGroup;
    template: string;
    user: User;

    constructor(
        private modalService: ModalService,
        private formBuilder: UntypedFormBuilder,
        private sessionService: SessionService,
        private portalService: PortalService,
        private toastr: ToastrService

    ){}


    ngOnInit() {
        this.busy = false;
        this.currentEmail = {} as EdlEmail;
        if(AccessRoleHelper.isEDLAdmin(this.sessionService.user.AccessRoleID)){
            this.portalService
                .getEmailContent()
                .subscribe((result: [EdlEmail]) => {
                    this.emails = result;

                }, error => {

            });
            this.portalService
                .getEmailTemplate()
                .subscribe((result: string) => {
                    this.template = result;
                }, error => {

            });
        }
        this.buildForm();
    }
    buildForm() {
        this.form = this.formBuilder.group({
            EmailType: [null, []],
            FriendlyName: [null, []],
            Subject: [null, []],
            Body: [null, []],
            RepeatContent: [null, []]
        });
    }
    onEmailChange() {
        var selectbox = <HTMLInputElement>document.getElementById("emailSelector");
        let emailContent: EdlEmail;
        this.emails.forEach(function(email) {
            let val: string = selectbox.value;
            if (email.EmailType == val) {
                emailContent = email;
            }
        })

        this.currentEmail = emailContent;
        this.form = this.formBuilder.group({
            EmailType: [this.currentEmail.EmailType,[]],
            FriendlyName: [this.currentEmail.FriendlyName, []],
            Subject: [this.currentEmail.Subject, []],
            Body: [this.currentEmail.Body, []],
            RepeatContent: [this.currentEmail.RepeatContent, []]
        });
    }
    preview({value}: {value: EdlEmail}) {
        if (value != null) {
            let preview: EdlEmail = value;
            preview.Body = preview.Body.replace("{complyitem}", "Item of Compliance");
            preview.Body = preview.Body.replace("{cplPersonOfContact}", "Abraham Maslow");
            preview.Body = preview.Body.replace("{cplInstructions}", "Example Instructions. Lorem ipsum dolor sit amet, ea vis tritani legimus luptatum, in mea dolorum petentium. Eu sed fabulas gubergren urbanitas, ex quem graeci everti per. Mel ea quidam causae iudicabit, at has regione civibus accommodare.");
            preview.Body = preview.Body.replace("{cplRequirements}", "Example Requirements. Lorem ipsum dolor sit amet, ea vis tritani legimus luptatum, in mea dolorum petentium. Eu sed fabulas gubergren urbanitas, ex quem graeci everti per. Mel ea quidam causae iudicabit, at has regione civibus accommodare.");
            preview.Body = preview.Body.replace("{cplLink}", "https://comply.edulinksolutions.com");
            preview.Body = preview.Body.replace("{registerLink}", "https://comply.edulinksolutions.com");
            preview.Body = preview.Body.replace("{message}", "Example Message to the end user.");
            preview.Body = preview.Body.replace("{portalName}", "Example Portal Name");
            preview.Body = preview.Body.replace("{edlUserName}", "Ivan Pavlov");
            preview.Body = preview.Body.replace("{edlUserEmail}", "catherine.of.aragon@email.com");
            preview.Body = preview.Body.replace("{oldEdlUserEmail}", "anne.boleyn@email.com");
            preview.Body = preview.Body.replace("{passwordResetLink}", "https://comply.edulinksolutions.com");
            preview.Body = preview.Body.replace("{cycleStartDate}", "04/22/2014");
            preview.Body = preview.Body.replace("{cycleEndDate}", "01/18/2016");
            preview.Body = preview.Body.replace("{cycleLink}", "https://comply.edulinksolutions.com");
            preview.Body = preview.Body.replace("{cycleUserName}", "Carl Jung");
            preview.Body = preview.Body.replace("{complyStatus}", "Example Status");
            preview.Body = preview.Body.replace("{cycleApprover}", "B.F. Skinner");
            preview.Body = preview.Body.replace("{complyLink}", "https://comply.edulinksolutions.com");
            preview.Body = preview.Body.replace("{complyForgotPasswordLink}", "https://comply.edulinksolutions.com");
            preview.Body = preview.Body.replace("{registerLink}", "https://comply.edulinksolutions.com");
            preview.Body = preview.Body.replace("{batchId}", "Example Batch ID");
            preview.Body = preview.Body.replace("{submittedDate}", "08/10/1982");
            preview.Body = preview.Body.replace("{error}", "Example Error Massage");
            preview.Body = preview.Body.replace("{submittedBy}", "Sigmund Freud");
            preview.Body = preview.Body.replace("{successCount}", "1776");
            preview.Body = preview.Body.replace("{errorCount}", "1776");
            preview.Body = preview.Body.replace("{createdCount}", "1779");
            preview.Body = preview.Body.replace("{currentUser}", "Frasier Crane")


            let emailHTML: string = preview.Body.replace("h1","h3");

            this.modalService
                .preview(emailHTML);
        }
    }
    submit({ value, valid }: { value: EdlEmail, valid: boolean}) {
        if (value != null) {
            this.busy = true;

            this.portalService
                .updateEmailContent(value)
                .pipe(
                    finalize( () => this.busy = false)
                )
                .subscribe((result: any) => {

                    this.toastr.success('Email Content updated.');

                }, error => {
                    this.busy = false;
                })

        }
    }

}
